// Unpublished Work © 2025 Deere & Company.

import {INVALID_RESPONSE_CODE} from '../constants/error-messages';
import {redirect} from '../helpers/redirect-helper';
import {getBaseConfig} from './config-service';

const DEFAULT_ENVIRONMENT = 'prod';

async function getEnvironment(): Promise<string> {
    try {
        const config = await getBaseConfig();
        return config?.environment ?? DEFAULT_ENVIRONMENT;
    } catch {
        return DEFAULT_ENVIRONMENT;
    }
}

export async function getRedirectUrl(): Promise<void> {
    try {
        const result = await fetch(`/api/redirect`);

        if (!result.ok) {
            throw new Error(INVALID_RESPONSE_CODE);
        }

        const url = await result.json();

        redirect(url.redirectUrl);
    } catch {
        const env = await getEnvironment();

        const mapUrl = env === DEFAULT_ENVIRONMENT ? 'https://map.deere.com' : `https://map-${env}.deere.com`;

        redirect(mapUrl);
    }
}
